import { useSelector } from "react-redux";
import "./styleC.css";
import { useNavigate, useParams } from "react-router-dom";
import Styles from "./PackageDetails.module.css";
import { Get_Package_Type } from "../../Model/HomeModel";
export default function MobileCourse({
  setEnrollActive,
  setCourseId,
  setBookADemoActive,
}) {
  const { DetailsPack } = useSelector((s) => s.packageDetailsReducer);
  const { id } = useParams();
  const Navigate = useNavigate();
  const Package_Type = Get_Package_Type(DetailsPack?.PackageId?.PackageType);
  return (
    <div className="Package_Mbl_det_Page ">
      <div className="container Mobile_View_css">
        {/* <!-- Course Header Card --> */}
        <div className="course-header">
          <h1 className="course-title"> {DetailsPack?.PackageId?.Name}</h1>
          <div className="rating-section">
            <div className="stars">
              <span className="star filled">★</span>
              <span className="star filled">★</span>
              <span className="star filled">★</span>
              <span className="star filled">★</span>
              <span className="star">★</span>
            </div>
            <span className="rating-text">256 ratings | 100 students</span>
          </div>
        </div>

        {/* <!-- Course Details --> */}
        <div className="course-details">
          <h2 className="section-title">{DetailsPack?.PackageId?.Detail}</h2>
          <div className="details-row">
            <div className="detail-item">
              {/* <div className="detail-icon package-icon">
               
              </div> */}
              <div>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    opacity="0.2"
                    x="0.5"
                    y="0.5"
                    width="31"
                    height="31"
                    rx="7.5"
                    fill="#59E270"
                    fill-opacity="0.8"
                    stroke="#3DC755"
                  />
                  <g clip-path="url(#clip0_2615_11614)">
                    <path
                      d="M15.4854 19.8857C14.3997 19.8857 13.314 19.8857 12.2283 19.8857C11.4854 19.8857 11.0854 19.4857 11.1426 18.7429C11.2569 15.1429 13.5997 12.2286 17.0283 11.3714C17.6569 11.2 18.2854 11.1429 18.914 11.1429C19.4854 11.0857 19.9426 11.5429 19.9426 12.1143C19.9426 14.4 19.9426 16.6286 19.9426 18.9143C19.9426 19.4857 19.5426 19.8857 18.9712 19.8857C17.7712 19.8857 16.6283 19.8857 15.4854 19.8857Z"
                      fill="#3DC755"
                    />
                    <path
                      d="M17.9428 8.17143C14.6857 8.17143 11.4285 8.17143 8.17137 8.17143C8.17137 11.4286 8.17137 14.6857 8.17137 17.9429C8.51423 17.9429 8.85709 17.9429 9.1428 17.9429C9.59994 17.9429 9.9428 18.2286 10.0571 18.6857C10.1714 19.2571 9.77137 19.8286 9.19994 19.8857C8.51423 19.8857 7.77137 19.8857 7.08566 19.8857C6.62852 19.8857 6.22852 19.4857 6.22852 19.0286C6.22852 18.9714 6.22852 18.9143 6.22852 18.8C6.22852 14.9714 6.22852 11.1429 6.22852 7.31429C6.22852 7.20001 6.22852 7.02858 6.28566 6.91429C6.39994 6.45715 6.7428 6.22858 7.25709 6.22858C11.1428 6.22858 15.0285 6.22858 18.9714 6.22858C19.5428 6.22858 19.9428 6.62858 19.9428 7.20001C19.9428 7.82858 19.9428 8.45715 19.9428 9.14286C19.9428 9.71429 19.5428 10.1143 18.9714 10.1143C18.3999 10.1143 17.9999 9.71429 17.9999 9.14286C17.9428 8.80001 17.9428 8.51429 17.9428 8.17143Z"
                      fill="#3DC755"
                    />
                    <path
                      d="M23.8285 18.4572C23.7714 16.5143 22.9714 15.0286 21.3714 13.9429C20.8571 13.6 20.7428 12.9714 21.0285 12.5143C21.3142 12.0572 21.8857 12 22.3999 12.2857C23.4857 12.9714 24.3428 13.8857 24.9142 15.0286C27.1999 19.4286 24.6285 24.6857 19.7714 25.6572C16.9142 26.2286 13.7714 24.8572 12.2857 22.3429C11.9999 21.8857 12.1142 21.2572 12.5714 20.9714C13.0285 20.6857 13.5999 20.8 13.9428 21.2572C14.3999 22 15.0285 22.5714 15.7714 23.0286C19.0285 24.9714 23.2571 22.9143 23.7714 19.2C23.7714 18.9714 23.8285 18.6857 23.8285 18.4572Z"
                      fill="#3DC755"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2615_11614">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(6 6)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="detail-content">
                <span className="detail-label">Package Type</span>
                <span className="detail-value">
                  {DetailsPack?.PackageId?.PackageType}
                </span>
              </div>
            </div>
            <div className="detail-item">
              {/* <div className="detail-icon duration-icon">⏱</div> */}
              <div>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    opacity="0.2"
                    x="0.5"
                    y="0.5"
                    width="31"
                    height="31"
                    rx="7.5"
                    fill="#DB24A1"
                    fill-opacity="0.8"
                    stroke="#DB24A1"
                  />
                  <g clip-path="url(#clip0_2615_11625)">
                    <path
                      d="M6.22852 16C6.22852 10.5714 10.6285 6.22858 16.0571 6.22858C21.4285 6.22858 25.8285 10.6857 25.8285 16C25.8285 21.4286 21.3714 25.7714 15.9428 25.7714C10.5714 25.7714 6.22852 21.3143 6.22852 16ZM15.9999 8.00001C11.5999 8.00001 7.99994 11.6 7.99994 16C7.99994 20.4 11.5999 24 15.9999 24C20.4571 24 23.9999 20.4 23.9999 16C23.9999 11.6 20.3999 8.00001 15.9999 8.00001Z"
                      fill="#DB24A1"
                    />
                    <path
                      d="M15.1426 13.3143C15.1426 12.4 15.1426 11.4857 15.1426 10.6286C15.1426 10.1714 15.4854 9.82858 15.8854 9.77144C16.3426 9.7143 16.7426 10 16.8569 10.4C16.8569 10.5714 16.8569 10.6857 16.8569 10.8C16.8569 12.3429 16.8569 13.8857 16.8569 15.4286C16.8569 15.6 16.914 15.6572 17.0283 15.7714C17.7712 16.5143 18.514 17.2572 19.2569 18C19.4854 18.2286 19.5997 18.5714 19.4854 18.9143C19.3712 19.2572 19.1426 19.4857 18.7997 19.5429C18.514 19.6 18.2283 19.5429 17.9997 19.3143C17.0854 18.4 16.2283 17.5429 15.314 16.6286C15.1426 16.4572 15.0854 16.2286 15.0854 15.9429C15.1426 15.0857 15.1426 14.1714 15.1426 13.3143Z"
                      fill="#DB24A1"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2615_11625">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(6 6)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="detail-content">
                <span className="detail-label">Duration</span>
                <span className="detail-value">
                  {DetailsPack?.PackageId?.Duration} Weeks
                </span>
              </div>
            </div>
            <div className="detail-item">
              {/* <div className="detail-icon level-icon">📊</div> */}
              <div>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    opacity="0.2"
                    x="0.5"
                    y="0.5"
                    width="31"
                    height="31"
                    rx="7.5"
                    fill="#6559E2"
                    fill-opacity="0.8"
                    stroke="#6559E2"
                  />
                  <path
                    d="M9.31424 23.7857H9.02853C8.57139 23.7857 8.17139 23.3857 8.17139 22.9286V17.2714C8.17139 16.8143 8.57139 16.4143 9.02853 16.4143H9.31424C9.77139 16.4143 10.1714 16.8143 10.1714 17.2714V22.9286C10.1714 23.3857 9.77139 23.7857 9.31424 23.7857Z"
                    fill="#6559E2"
                  />
                  <path
                    d="M13.9998 23.7857H13.7141C13.2569 23.7857 12.8569 23.3857 12.8569 22.9286V14.2429C12.8569 13.7857 13.2569 13.3857 13.7141 13.3857H13.9998C14.4569 13.3857 14.8569 13.7857 14.8569 14.2429V22.9286C14.8569 23.3857 14.4569 23.7857 13.9998 23.7857Z"
                    fill="#6559E2"
                  />
                  <path
                    d="M18.6858 23.7857H18.4001C17.943 23.7857 17.543 23.3857 17.543 22.9286V10.4714C17.543 10.0143 17.943 9.61429 18.4001 9.61429H18.6858C19.143 9.61429 19.543 10.0143 19.543 10.4714V22.9286C19.543 23.3857 19.2001 23.7857 18.6858 23.7857Z"
                    fill="#6559E2"
                  />
                  <path
                    d="M23.3714 23.7857H23.0857C22.6285 23.7857 22.2285 23.3857 22.2285 22.9286V7.72857C22.2285 7.27143 22.6285 6.87143 23.0857 6.87143H23.3714C23.8285 6.87143 24.2285 7.27143 24.2285 7.72857V22.9286C24.2857 23.3857 23.8857 23.7857 23.3714 23.7857Z"
                    fill="#6559E2"
                  />
                </svg>
              </div>
              <div className="detail-content">
                <span className="detail-label">Level Type</span>
                <span className="detail-value">Intermediate</span>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Hero Section --> */}
        <div className="hero-section">
          <div className="hero-content">
            <div className="hero-text">
              <h2 className="hero-title">Book A Demo For Live Classes</h2>
              <p className="hero-subtitle">
                Get an overall view of the course and understand your
                preparation journey
              </p>
            </div>
            <div className="hero-image">
              <img
                src="https://images.pexels.com/photos/3769021/pexels-photo-3769021.jpeg?auto=compress&cs=tinysrgb&w=400"
                alt="Student with books"
                className="student-image"
              />
            </div>
          </div>
          <div className="hero-decorations">
            <div className="decoration-shape shape-1"></div>
            <div className="decoration-shape shape-2"></div>
            <div className="decoration-shape shape-3"></div>
          </div>
        </div>

        {/* <!-- About Section --> */}
        <div className="about-section">
          <h2 className="section-title">About This Package</h2>
          <p className="about-text">
            <div
              contentEditable="false"
              dangerouslySetInnerHTML={{
                __html: DetailsPack?.PackageId?.Description,
              }}
            ></div>
          </p>
        </div>

        {/* <!-- Course Card --> */}
        <div className="course-card">
          <div className="course-card-header">
            <div
              className="course-badge"
              style={{
                background: Package_Type?.color ? Package_Type?.color : "green",
              }}
            >
              <span className="badge-text">{Package_Type?.name}</span>
            </div>
          </div>
          <h3 className="course-card-title" style={{ marginTop: "30px" }}>
            {DetailsPack?.PackageId?.Name}
          </h3>
          <div className="course-price">
            {DetailsPack?.PackageId?.DiscountedPrice ? (
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <span>
                  Price : ₹ {DetailsPack?.PackageId?.DiscountedPrice} /-
                </span>{" "}
                <span className={Styles.Price_Hided}>
                  ₹ {DetailsPack?.PackageId?.ActualCost}
                </span>{" "}
              </div>
            ) : (
              <span>₹ {DetailsPack?.PackageId?.ActualCost}</span>
            )}
          </div>

          <div className="course-features ">
            {DetailsPack?.LIVE_CLASSES ? (
              <div className="feature">
                <img
                  src="/assets/image/ProductCard-Icon/icon_LIVE_CLASSES.svg"
                  alt="icon_LIVE_CLASSES"
                />

                <span>{DetailsPack?.LIVE_CLASSES} LIVE CLASSES </span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.One_On_One_DOUBT_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
                    alt="icon_LIVE_CLASSES"
                  />
                </span>
                <span>1:1 DOUBT SESSIONS </span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.DOUBT_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
                    alt="icon_LIVE_CLASSES"
                  />
                </span>
                <span> DOUBT SESSIONS</span>
              </div>
            ) : (
              ""
            )}
            {DetailsPack?.SESSION_TESTS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_SESSION_TESTS.svg"
                    alt="icon_SESSION_TESTS"
                  />
                </span>
                <span>SESSION TESTS </span>
              </div>
            ) : (
              ""
            )}
            {DetailsPack?.STUDY_MATERIAL_ACCESS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_STUDY_MATERIAL_ACCESS.svg"
                    alt="icon_STUDY_MATERIAL_ACCESS"
                  />
                </span>
                <span> STUDY MATERIAL ACCESS</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.COMPLETE_MOCK_TEST ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_MOCK_TEST.svg"
                    alt="icon_MOCK_TEST"
                  />
                </span>
                <span>
                  {DetailsPack?.COMPLETE_MOCK_TEST} COMPLETE MOCK TEST
                </span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.COMPLETE_MOCK_TEST_AI ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_MOCK_TEST_AI.svg"
                    alt="icon_MOCK_TEST"
                  />
                </span>
                <span>
                  {DetailsPack?.COMPLETE_MOCK_TEST_AI} COMPLETE MOCK TEST
                  (POWERED BY AI)
                </span>
              </div>
            ) : (
              ""
            )}
            {DetailsPack?.TESTIFYI_REALITY_TEST ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_reality_test.svg"
                    alt="icon_reality_test"
                  />
                </span>
                <span>
                  {" "}
                  {DetailsPack?.TESTIFYI_REALITY_TEST} TESTIFYI REALITY TEST
                </span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.MASTER_CLASS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Master_class.svg"
                    alt="icon_Master_class"
                  />
                </span>
                <span>MASTER CLASS</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.One_On_One_SPEAKING_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Speaking_Session.svg"
                    alt="icon_Speaking_Session"
                  />
                </span>
                <span>1:1 SPEAKING SESSIONS</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.LANGUAGE_PRACTICE_TEST ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_LANGUAGE_PRACTICE_TEST.svg"
                    alt="icon_LANGUAGE_PRACTICE_TEST"
                  />
                </span>
                <span>
                  {DetailsPack?.LANGUAGE_PRACTICE_TEST} TESTIFYI PRACTICE TEST
                </span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.GRAMMAR_TEST === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_GRAMMAR_TEST.svg"
                    alt="icon_GRAMMAR_TEST"
                  />
                </span>
                <span>GRAMMAR TEST</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.MOCK_INTERVIEW === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Mock_INTERVIEW.svg"
                    alt="icon_Mock_INTERVIEW"
                  />
                </span>
                <span>MOCK INTERVIEW</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.GROUP_DISCUSSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_GROUP_DISCUSSIONS.svg"
                    alt="icon_GROUP_DISCUSSIONS"
                  />
                </span>
                <span>GROUP DISCUSSIONS</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.BUSINESS_ENGLISH_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_BUSINESS_ENGLISH_SESSIONS.svg"
                    alt="icon_BUSINESS_ENGLISH_SESSIONS"
                  />
                </span>
                <span>BUSINESS ENGLISH SESSIONS</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.SOFT_SKILLS_SESSION === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_SOFT_SKILLS_SESSION.svg"
                    alt="icon_SOFT_SKILLS_SESSION"
                  />
                </span>
                <span>SOFT SKILLS SESSION</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.EXPERT_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_LIVE_CLASSES.svg"
                    alt="icon_EXPERT_SESSIONS"
                  />
                </span>
                <span> EXPERT SESSIONS</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.WEEKLY_DOUBT_SESSION === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Speaking_Session.svg"
                    alt="icon_WEEKLY_DOUBT_SESSION"
                  />
                </span>
                <span>WEEKLY DOUBT SESSION</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.STUDY_MATERIAL === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_STUDY_MATERIAL_ACCESS.svg"
                    alt="icon_STUDY_MATERIAL"
                  />
                </span>
                <span>STUDY MATERIAL</span>
              </div>
            ) : (
              ""
            )}

            {DetailsPack?.PRACTICE_PORTAL === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_SESSION_TESTS.svg"
                    alt="icon_PRACTICE_PORTAL"
                  />
                </span>
                <span>PRACTICE PORTAL</span>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="course-actions">
            <button className="btn btn-outline">
              {" "}
              <a
                style={{
                  color: "#007bff",
                  textDecoration: "none",
                }}
                href="tel:+919289192873"
              >
                {" "}
                Speak with Us
              </a>
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setEnrollActive(id);
                setCourseId(DetailsPack?.PackageId?.CourseId);
              }}
            >
              Enroll Now
            </button>
          </div>
        </div>

        {/* <!-- Demo Section --> */}
        <div className="demo-section">
          <div className="demo-content">
            <h2 className="demo-title">Book A Demo For Live Classes</h2>
            <p className="demo-subtitle">
              Get an overall view of the course and understand your preparation
              journey
            </p>
            <div className="demo-actions">
              <button
                className="btn btn-outline"
                onClick={() => Navigate("/contact-us")}
              >
                Let's Connect
              </button>
              <button
                onClick={() => setBookADemoActive(true)}
                className="btn btn-primary"
              >
                Book A Demo
              </button>
            </div>
          </div>
          <div className="demo-image">
            <img
              src="https://images.pexels.com/photos/3184298/pexels-photo-3184298.jpeg?auto=compress&cs=tinysrgb&w=400"
              alt="Instructor with books"
              className="instructor-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
